import React, { useMemo, useState } from "react";
import { Button, Card, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FormInput, VerticalForm } from "../../components";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { RootState } from "../../redux/store";
import api from "../../utils/ApiMethod";
import { useSelector } from "react-redux";

interface UserData {
  username: string;
  enrollment_no: string;
  total_marks_Theory: string;
  obtained_marks_Theory: string;
  total_marks_Practical: string;
  obtained_marks_Practical: string;
}

const AddMarksModal = (ugStudent: any, selectedDropdownValue: any) => {
  // console.log(ugStudent, "ugStudent");
  const [show, setShow] = useState<boolean>(false);
  const handleClose = () => {
    setShow(false);
    setPercentFroTheory(0);
    setMarks({
      username: "",
      enrollment_no: "",
      total_marks_Theory: "",
      obtained_marks_Theory: "",
      total_marks_Practical: "",
      obtained_marks_Practical: "",
    });
    // setPercentForPractical(0);
    // setMonth("");
  };
  //   const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [marks, setMarks] = useState<UserData>({
    username: ugStudent?.name,
    enrollment_no: ugStudent?.enrollment_no,
    total_marks_Theory: "",
    obtained_marks_Theory: "",
    total_marks_Practical: "",
    obtained_marks_Practical: "",
  });

  const [percentForTheory, setPercentFroTheory] = useState<number | any>(0);
  // const [percentForPractical, setPercentForPractical] = useState<number | any>(
  //   0
  // );
  // const [month, setMonth] = useState(ugStudent.selectedDate);
  //   console.log(month,"month");

  const handleChange = (e: React.ChangeEvent<any>) => {
    const {
      name,
      value,
      //  files, type, checked, date
    } = e.target;
    setMarks((prevD) => ({ ...prevD, [name]: value }));
  };
  const [errorMessage, setErrorMessage] = useState("");

  useMemo(() => {
    try {
      if (marks.obtained_marks_Theory > marks.total_marks_Theory) {
        setErrorMessage("InValid number entered");
      } else {
        const totalMarks =
          Number(marks.total_marks_Theory) +
          Number(marks.total_marks_Practical);
        const totalMarksObtained =
          Number(marks.obtained_marks_Theory) +
          Number(marks.obtained_marks_Practical);
        // console.log(
        //   totalMarks,
        //   "totalMarks",
        //   totalMarksObtained,
        //   "totalMarksObtained"
        // );
        const result = (Number(totalMarks) * Number(totalMarksObtained)) / 100;
        setPercentFroTheory(result.toFixed(2));
        setErrorMessage("");
      }
    } catch (error) {
      console.log(error, "error");
    }
  }, [
    marks.obtained_marks_Theory,
    marks.total_marks_Theory,
    marks.total_marks_Practical,
    marks.obtained_marks_Practical,
  ]);

  const {
    user,
    // userLoggedIn, loading, error, userId
  } = useSelector((state: RootState) => ({
    user: state.Auth.user,
    loading: state.Auth.loading,
    error: state.Auth.error,
    userLoggedIn: state.Auth.userLoggedIn,
    userId: state.Auth._id,
  }));

  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  //   let Role = user.hobbies ? user.hobbies : user.user.hobbies;
  let profileName = user.name
    ? user.name
    : user.first_name
    ? user.first_name
    : user.user.name;
  //   let subDepartmentName = user.department
  //     ? user.department
  //     : user.user.department;

  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const handleSubmitMarks = async (e: any) => {
    e.preventDefault();
    alert(
      `Adding Marks For \n Student Name: ${ugStudent.name} \n Enrollment_No : ${ugStudent.enrollment_no}`
    );
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      // setButtonLoading(true);
      const formData = new FormData();
      // Object.entries(marks).forEach(([key, value]) => {
      //   formData.append(key, value);
      // });
      // form.append()
      formData.append("username", ugStudent?.name);
      formData.append("enrollment_no", ugStudent?.enrollment_no);
      formData.append("total_marks_Theory", marks.total_marks_Theory);
      formData.append("obtained_marks_Theory", marks.obtained_marks_Theory);
      formData.append("total_marks_Practical", marks.total_marks_Practical);
      formData.append("obtained_marks_Practical", marks.obtained_marks_Practical);
      formData.append("percentForTheory", percentForTheory);
      // formData.append("percentForPractical", percentForPractical);
      formData.append(
        "session",
        ugStudent.selectedDropdownValue.selectedSession
      );
      formData.append(
        "CourseName",
        ugStudent.selectedDropdownValue.selectedCourse
      );
      formData.append("Exam", ugStudent.selectedDropdownValue.selectedExam);
      formData.append(
        "Subjects",
        ugStudent.selectedDropdownValue.selectedSubjects
      );
      // formData.append("AtendanceOfMonth", month);
      formData.append("createdBy", profileName);
      handleClose();
      try {
        const response = await api.createData(
          `/api/add/studentMarks/${profileId}/${Key_Key}/${ugStudent?.id}`,
          formData
        );
        if (response.status === 440) {
          alert("Session Expired");
          // dispatch(logoutUser());
          window.location.href = "http://localhost:3004/student/login";
        } else if (response.status === 429) {
          // setShowModal(true);
        } else if (response.status === 400) {
          // setIsError(true);
          let errorMessage = await response.message;
          console.log(errorMessage, "Error Message");
          // setIsResponse(errorMessage);
        } else if (response.status === 200 || response.status === 201) {
          alert(
            `Added Marks For \n Student Name: ${ugStudent?.name} \n Enrollment_No : ${ugStudent?.enrollment_no}`
          );
          // setShowToast(true);

          // window.location.reload();
          // setButtonLoding(false);
        }
      } catch (error) {
        console.error("Error during marks submition:", error);
      }
    }
  };

  //   console.log({ ugStudent }, "ugstudent modal");
  //   console.log(ugStudent.selectedDropdownValue.selectedSession, "selectedData");
  const schemaResolver = yupResolver(
    yup.object().shape({
      total_No_of_Class_Theory: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),
      total_Class_Attended_Theory: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),
      percentage_Theory: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),
      total_No_of_Class_Practical_Clinical_Posting: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),
      total_Class_Attended_Practical_Clinical_Posting: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),
      percentage_Practical_Clinical_Posting: yup
        .number()
        .required("Please enter Total_No_of_Class_Theory only in number"),

      //   confirmpassword: yup
      //     .string()
      //     .oneOf([yup.ref("password"), null], "Passwords don't match")
      //     .required("This value is required."),
      //   checkbox: yup.bool().oneOf([true]),
    })
  );

  // console.log(marks.total_No_of_Class_Theory,"total_No_of_Class_Theory");

  return (
    <>
      <div className="button-list">
        <Link to="" onClick={handleShow}>
          Add Marks
        </Link>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header
          onHide={handleClose}
          closeButton
          style={{ background: "silver", color: "wheat" }}
        >
          <Modal.Title as="h5">Add Marks</Modal.Title>
        </Modal.Header>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "1rem",
          }}
        >
          <FormInput
            label={"Session"}
            //   type="text"
            name="enrollment_no"
            //   placeholder="Enter email"
            value={ugStudent.selectedDropdownValue.selectedSession}
            containerClass={"mb-1"}
            disabled
            style={{ border: "0", boxShadow: "none" }}
          />
          <FormInput
            label={"Course"}
            //   type="text"
            name="enrollment_no"
            //   placeholder="Enter email"
            value={
              ugStudent.selectedDropdownValue.selectedCourse === "01"
                ? "MBBS"
                : "Nurshing"
            }
            containerClass={"mb-2"}
            style={{ border: "0", boxShadow: "none" }}
            disabled
          />
          <FormInput
            label={"Exam"}
            type="text"
            name="enrollment_no"
            //   placeholder="Enter email"
            value={ugStudent.selectedDropdownValue.selectedExam}
            containerClass={"mb-2"}
            style={{ border: "0", boxShadow: "none" }}
            disabled
          />
          <FormInput
            label={"Suject"}
            type="text"
            name="enrollment_no"
            //   placeholder="Enter email"
            value={ugStudent.selectedDropdownValue.selectedSubjects}
            containerClass={"mb-2"}
            style={{ border: "0", boxShadow: "none" }}
            disabled
          />
        </div>
        <Modal.Body>
          <h6>Student Marks </h6>
          <Card>
            <Card.Body>
              <Form onSubmit={(e) => handleSubmitMarks(e)}>
                {/* <h4>Name : {ugStudent.ugStudent.first_name}</h4>
              <p className="sub-header">
                React validation with react-hook-form library.
              </p> */}
                <VerticalForm<UserData>
                  onSubmit={() => {}}
                  resolver={schemaResolver}
                  // defaultValues={{ username: "test" }}
                >
                  <FormInput
                    label={"Name"}
                    type="text"
                    name="username"
                    value={ugStudent?.name}
                    containerClass={"mb-3"}
                    disabled
                  />
                  <FormInput
                    label={"Enrollment No."}
                    type="text"
                    name="enrollment_no"
                    value={ugStudent.enrollment_no}
                    containerClass={"mb-3"}
                    disabled
                  />
                  <FormInput
                    label={"Total Theory Marks"}
                    type="number"
                    name="total_marks_Theory"
                    value={marks.total_marks_Theory}
                    placeholder="total_marks_Theory(Number only)"
                    onChange={handleChange}
                    containerClass={"mb-3"}
                  />
                  <FormInput
                    label={"Obtained Theory Marks"}
                    type="number"
                    name="obtained_marks_Theory"
                    placeholder="obtained_marks_Theory"
                    value={marks.obtained_marks_Theory}
                    onChange={handleChange}
                    containerClass={"mb-3"}
                  />

                  <FormInput
                    label={"Total Practical Marks"}
                    type="number"
                    onChange={handleChange}
                    value={marks.total_marks_Practical}
                    name="total_marks_Practical"
                    placeholder="total_marks_Practical"
                    containerClass={"mb-3"}
                  />
                  <FormInput
                    label={"Obtained Practical Marks"}
                    type="number"
                    name="obtained_marks_Practical"
                     value={marks.obtained_marks_Practical}
                    placeholder="obtained_marks_Practical"
                    onChange={handleChange}
                    containerClass={"mb-3"}
                    required
                  />
                  {errorMessage}
                  <FormInput
                    label={"Percentage(%)"}
                    type="number"
                    name="percentForTheory"
                    value={percentForTheory}
                    //   onChange={(e) => handleTheoryPercentage()}
                    containerClass={"mb-3"}
                    disabled
                  />
                </VerticalForm>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Close
          </Button>{" "}
          <Button variant="primary" onClick={(e) => handleSubmitMarks(e)}>
            Submit Marks
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddMarksModal;
